<div class="modal-body h-full">
  <header class="modal-header">
    <div class="flex items-baseline mat-dialog-title">
      <h2 class="!text-2xl modal-headline" i18n>Notes & attachments</h2>
      <div class="ml-auto">
        <button mat-icon-button [mat-dialog-close]="null" class="button-close">
          <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
          <span class="sr-only" i18n>Close</span>
        </button>
      </div>
    </div>
  </header>
  <mat-dialog-content class="w-full h-[345px]">
    <div class="my-2">
      <span class="field-label float-left">Notes</span>
      <sp-editor
        [placeholder]="'Add notes'"
        [ngModel]="notes === 'Multiple-values' ? '' : notes"
        (ngModelChange)="onNotesChange($event)"
        [placeholder]="notes === 'Multiple-values' ? 'Multiple-values' : 'Add notes'"
        [maxLength]="5000"
        [taggingOptions]="taggingOptions"
        (usersList)="taggedUserList($event)"
        (descriptionText)="editorDescriptionText($event)"
      ></sp-editor>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="modal-footer flex justify-end sticky bottom-0">
      <button mat-flat-button class="button-primary" (click)="submit()">
        <mat-icon class="material-icons-outlined">check</mat-icon>
        <span class="px-2 font-bold" i18n>Submit</span>
      </button>
    </div>
  </mat-dialog-actions>
</div>
